import { Component, inject, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormGroup,
  NonNullableFormBuilder,
  ReactiveFormsModule,
} from '@angular/forms';
import { CurrencyPipe, NgClass } from '@angular/common';
// PrimeNG
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { RadioButtonModule } from 'primeng/radiobutton';
// Models
import { ControlsOf } from '@shared/models-v3/controls-of.type';
import { SelectDate } from '../shipping-product-list/models/select-date.interface';
// Pipes
import { ShippingDatePipe } from '@shared/pipes-v2/shipping-date.pipe';

const NG_MODULES = [CurrencyPipe, NgClass, ReactiveFormsModule];
const PIPES = [ShippingDatePipe];
const PRIME_MODULES = [SidebarModule, ButtonModule, RadioButtonModule];

@Component({
  selector: 'app-group-date-sidebar',
  standalone: true,
  imports: [NG_MODULES, PRIME_MODULES, PIPES],
  templateUrl: './group-date-sidebar.component.html',
  styleUrl: './group-date-sidebar.component.scss',
})
export class GroupDateSidebarComponent {
  //#region Inputs & Outputs
  @Input() availableDates!: any[];
  @Input() indexGroup!: number;
  @Input() selectedDateIndex: number | null = null;
  @Output() onSubmit: EventEmitter<SelectDate> = new EventEmitter();
  //#endregion

  visible: boolean = false;
  todayDate = new Date();
  selectedDateForm!: FormGroup<ControlsOf<{ index: number | null }>>;

  //#region Getters
  get indexField() {
    return this.selectedDateForm.get('index');
  }
  //#endregion

  //#region Dependencies
  private readonly fb = inject(NonNullableFormBuilder);
  //#endregion

  constructor() {
    this.buildForm();
  }

  private buildForm(): void {
    this.selectedDateForm = this.fb.group({
      index: new FormControl<number | null>(null),
    });
  }

  /**
   * Mostrar el sidebar.
   * Se ejecuta desde el componente padre.
   * @returns void
   */
  show(): void {
    this.visible = true;
  }

  /**
   * Al mostrar el sidebar.
   */
  onShow(): void {
    if (typeof this.selectedDateIndex !== 'number') return;
    this.selectedDateForm.setValue({
      index: this.selectedDateIndex,
    });
  }

  submit(): void {
    this.visible = false;
    if (typeof this.indexField?.value !== 'number') return;
    this.onSubmit.emit({
      indexGroup: this.indexGroup,
      indexSelectedDate: this.indexField.value,
    });
  }

  /**
   * Al seleccionar fecha.
   * @param index - Índice de la fecha seleccionada.
   */
  onSelectDate(index: number): void {
    this.selectedDateForm.setValue({ index });
  }
}
